import { apiFetch } from "../../../lib/api/client";
import {
  questionnaireDraftSchema,
  questionnaireSchema,
  questionnaireVersionSchema,
  questionnaireVersionSummarySchema,
  type QuestionnaireAvailability,
} from "../schemas/questionnaireSchemas";

export async function getQuestionnaire() {
  return questionnaireSchema.parse(await apiFetch<unknown>("/questionnaire"));
}

export async function updateAvailability(command: QuestionnaireAvailability, rowVersion: number) {
  return questionnaireSchema.parse(
    await apiFetch<unknown>("/questionnaire/availability", {
      method: "PUT",
      headers: { "If-Match": `"${rowVersion}"` },
      body: JSON.stringify(command),
    }),
  );
}

export async function getQuestionnaireDraft() {
  return questionnaireDraftSchema.parse(
    await apiFetch<unknown>("/admin/questionnaire/draft"),
  );
}

export async function saveQuestionnaireDraft(
  command: { title: string; namedResponseNotice: string; questions: unknown[] },
  rowVersion: number,
) {
  return questionnaireDraftSchema.parse(
    await apiFetch<unknown>("/admin/questionnaire/draft", {
      method: "PUT",
      headers: { "If-Match": `"${rowVersion}"` },
      body: JSON.stringify(command),
    }),
  );
}

export async function publishQuestionnaireDraft(rowVersion: number) {
  return questionnaireSchema.parse(
    await apiFetch<unknown>("/admin/questionnaire/draft/publish", {
      method: "POST",
      headers: { "If-Match": `"${rowVersion}"` },
    }),
  );
}

export async function listQuestionnaireVersions() {
  return questionnaireVersionSummarySchema.array().parse(
    await apiFetch<unknown>("/admin/questionnaire/versions"),
  );
}

export async function getQuestionnaireVersion(versionId: string) {
  return questionnaireVersionSchema.parse(
    await apiFetch<unknown>(`/admin/questionnaire/versions/${versionId}`),
  );
}
